import React, { useState, useEffect } from "react";
import logo from './../../assets/img/favicon-dark.png';
import LZString from 'lz-string';
import DateUtil from '../../util/DateUtil';
import moment from "moment";
import { Table } from "antd";
import CommonUtils from '../../util/CommonUtils';
import SessionManager from "../../routes/SessionManager";
import API from '../../service/SiteKickAPIService';

function RainReport() {

    const getPathParams = () => {
        var pathParams = window.location.search;
        pathParams = pathParams.length > 0 ? pathParams.substring(1) : '';
        return pathParams.length > 0 ? JSON.parse(LZString.decompressFromBase64(pathParams)) : {};
    }
    const [user, setUser] = useState(getPathParams());
    const [loading, setLoading] = useState(true);
    const [rain_recs, setRainRecs] = useState([]);
    const [parseCoord, setParseCoord] = useState("");
    const [date, setDate] = useState(user.date);
    const [time, setTime] = useState(user.time);

    let sessionManager = new SessionManager();
    sessionManager.storeCookie('user', user);

    let timezone = user.site_selected ? user.site_selected.site_iana_timezone : moment.tz.guess();
    let accumulation = 0;
    let report_columns = [
        {
            title: "Date",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, rec) => moment.tz(parseInt(rec.local_epoch) * 1000, timezone).format('MMM DD, YYYY')
        },
        {
            title: "Time",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, rec) => moment.tz(parseInt(rec.local_epoch) * 1000, timezone).format('HH:01')
        },
        {
            title: "Amount of Rain",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, rec) => rec.rain,
        },
        {
            title: "Accumulation",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, rec) => {
                let rain = parseFloat(rec.rain);
                accumulation = accumulation + rain;
                return <>{accumulation.toFixed(2)}</>
            }
        },
    ];

    useEffect(() => {
        document.body.style.backgroundColor = '#fff';
        setUser(user);
        fetchWeatherReport();
    }, []);

    const fetchWeatherReport = (dateFormat = date, timeFormat = time) => {
        setLoading(true);

        let start_ts = DateUtil.getDbData(timezone, dateFormat + ' ' + timeFormat);
        let end_date = moment(dateFormat).subtract(3, 'days').format('YYYY-MM-DD');
        let end_ts = DateUtil.getDbData(timezone, end_date);

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: {
                "query": JSON.stringify({
                    attributes: ['local_epoch', 'json_extract(full_response, \'$.rain."1h"\') as rain', 'json_extract(full_response, \'$.coord\') as coordinates'],
                    object: 'weather_log',
                    filters: [
                        { operator: '=', attribute: 'weather', value: "Rain" },
                        { join_by: 'and', attribute: 'local_epoch', value: end_ts, operator: '>=' },
                        { join_by: 'and', attribute: 'local_epoch', value: start_ts, operator: '<=' }
                    ],
                    sort_by: [{ attribute: 'local_epoch', value: 'asc' }],
                    pagination: { page: 1, size: 100 }
                })
            }
        }

        CommonUtils.ajax(
            {
                url: API.DATA.EXPLORER,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    var prev_date = moment(date).subtract(1, 'days').format('YYYY-MM-DD');
                    let prevDayTS = DateUtil.getDbData(timezone, prev_date + ' ' + time);
                    if (res.data.length > 0 && res.data[res.data.length - 1].local_epoch > prevDayTS && res.data[res.data.length - 1].local_epoch < start_ts) {
                        let coord = res.data[0].coordinates;
                        setParseCoord(JSON.parse(coord));
                    } else {
                        setParseCoord("");
                    }
                    let data = [...res.data].reverse();
                    let records = [...res.data].reverse();

                    if (records.length <= 24) {
                        data = records.filter(r => r.local_epoch >= prevDayTS && r.local_epoch <= start_ts);
                    } else {
                        if (records[24].local_epoch > prevDayTS) {
                            data = records.filter(r => r.local_epoch >= prevDayTS && r.local_epoch <= start_ts);
                        }
                    }
                    data.reverse();
                    for (var d of data) {
                        d.date_format = moment.tz(parseInt(d.local_epoch) * 1000, timezone).format('YYYY-MM-DD HH');
                    }
                    //To insert '0' rain records for the Hr, if it's not available
                    let data_modified = [...data]
                    let start_ts_temp = start_ts;
                    for (var i = 0; i < 24; i++) {
                        let end_date_format = moment.tz(parseInt(start_ts_temp) * 1000, timezone).format('YYYY-MM-DD HH');

                        if (data.find(d => d.date_format === end_date_format) === undefined) {
                            data_modified.push({ 'local_epoch': start_ts_temp, 'rain': '0' });
                        }
                        start_ts_temp = start_ts_temp - 3600;
                    }

                    data_modified.sort((x, y) => x.local_epoch - y.local_epoch);
                    setLoading(false);
                    setRainRecs(data_modified);
                    setDate(date);
                    setTime(time);
                } else {
                    setLoading(false);
                    setRainRecs([]);
                    setDate(date);
                    setTime(time);
                }
            });
    }

    const setPDFContentReady = () => {
        window.status = 'ready';
    }

    return (
        <React.Fragment>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 my-5">
                        <span className="navbar-brand text-primary">
                            <img src={logo} alt="logo" style={{ width: "25px", marginRight: '10px' }} />
                            {"SiteSupt OnDemand"}
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12  p-1 mb-5">
                        <h4>Rain Report</h4>
                    </div>
                    <div className="col-md-12">
                        <h5 className="text-app">{user && user.site_selected && user.site_selected.site_name}</h5>
                    </div>
                </div>
                {parseCoord && <div className="row pt-1">
                    <div className="col-md-6 pt-1">
                        <b>Coordinates:</b>&nbsp;
                        <span className="font-size-5">
                            <label >Latitude:</label>&nbsp;<span>{parseCoord.lat} ,</span>
                        </span>
                        <span className="font-size-5">
                            <label >Longitude:</label>&nbsp;<span>{parseCoord.lon}</span>
                        </span>
                    </div>
                    <div className="col-md-6 pt-1" style={{ paddingLeft: "14rem" }}>
                        <span >
                            <b >Source:</b>&nbsp;
                            <span>OpenWeather</span>
                        </span>
                    </div>
                </div>}
                <div className="row bg-white">
                    {rain_recs && <div className="col-md-12 p-1">
                        <Table
                            loading={loading}
                            rowKey="local_epoch"
                            dataSource={rain_recs}
                            columns={report_columns}
                            pagination={false}
                        />
                    </div>
                    }
                </div>
                {!loading && setPDFContentReady()}
            </div>
        </React.Fragment>
    );
}

export default RainReport;